/* eslint-disable react/require-default-props */
import React from 'react';

type Props = {
  disabled?: boolean | undefined,
  label?: string,
  name: string,
  placeholder: string,
  setUserInfo: Function,
  userInfo: any,
  validValue: boolean,
  value: string,
}

function InputSmsField({
  label, name, value, setUserInfo, placeholder, userInfo, validValue, disabled = false,
} : Props) {
  return (
    <label htmlFor={name} className="flex flex-col w-full xs:w-1/2 sm:w-2/5 first-of-type:mt-[20px] mt-[25px]">
      <div className={`${validValue ? 'focus-within:border-darkCyan border-darkGreyBlue focus-within:border-b-2' : '!border-redWarning !border-b '} border-b flex flex-col items-center`}>
        <input
          required
          id={name}
          disabled={disabled}
          name={name}
          value={value}
          onChange={(e) => setUserInfo({ ...userInfo, [name]: e.target.value })}
          className="block pb-1 text-center outline-none focus:placeholder:text-transparent bg-transparent placeholder-darkGreyBlue/50 text-[18px]"
          placeholder={placeholder}
        />
      </div>
      {label && (
      <span className={`${!validValue && 'text-redWarning'} mt-0.5 text-left text-xs uppercase"`}>
        {label}
        {`${!validValue ? '*' : ''}`}
      </span>
      )}
    </label>
  );
}

export default InputSmsField;
